// src/new/components/monitor/TriageChat/triageBackend.ts

import { TriageContext } from './triageContext';

export interface HistoryMessage {
  role: 'user' | 'assistant' | 'tool';
  text: string;
  /** Non-empty only when this turn had subagent activity. Keyed by child
   * session id — same key space as live `subagent-start` events — so a
   * turn rendered from history and a turn rendered live use one bubble
   * shape. veda-ai backend never populates this. */
  subagents?: Record<string, SubagentState>;
}

export interface SubagentState {
  childSessionId: string;
  agent: string | null;
  title: string | null;
  taskPrompt: string | null;
  outputText: string;
  status: 'streaming' | 'done';
}

/** Shared by expressBackend.ts and useExpressChatSSE.ts — the only two
 * places that talk to express-code over HTTP — so the `Bearer` header isn't
 * hand-rolled at each call site. */
export function authHeaders(token: string): { Authorization: string } {
  return { Authorization: `Bearer ${token}` };
}

export interface TriageBackend {
  /** Discriminant so `useTriageChat` can select the matching transport hook
   * (`useVedaChatSocket` vs `useExpressChatSSE`) without either backend
   * implementation needing to know about React hooks. */
  readonly kind: 'veda' | 'express';
  readonly storageKeyPrefix: string;
  createSession(ctx: TriageContext): Promise<{ sessionId: string }>;
  getHistory(sessionId: string): Promise<HistoryMessage[]>;
  abortSession(sessionId: string): Promise<void>;
}
